import Cookies from 'js-cookie'
import axios from 'axios'

import { MessageBox, Message } from 'element-ui'

const TokenKey = 'Maintenance-System-Token'


// 请求本地配置

let getToken = () => {
  // return Cookies.get(TokenKey)
  return localStorage.getItem(TokenKey)
}

let SPDAPIURL = localStorage.getItem('smturl')

if(!SPDAPIURL){
  localStorage.setItem('smturl',JSON.stringify({}));
  SPDAPIURL = {};
}else {
  SPDAPIURL = JSON.parse(SPDAPIURL)
}

const service = axios.create({
  baseURL: SPDAPIURL.CURRENTAPIUrl + 'api', // url = base url + request url  process.env.VUE_APP_BASE_API
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    config.params = { 'token': getToken() }
    config.headers['token'] = getToken()
    // console.log('config', config)
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    // console.log('response.data', response.data)
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 1) {
      Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  }, error => {
    console.log('error.code',error.code)
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
